import { publicUrls } from "../../Api/Auth/AppUrls";
import AboutUs from "../../Pages/About";
import ContactUs from "../../Pages/Contact";
import FeCivil from "../../Pages/FeCivilCourses";
import FeMechanical from "../../Pages/FeMechanicalCourses";
import FreeFeMaterialsCivil from "../../Pages/FreeFeMaterials/Civil";
import FreeFeMaterialsMechanical from "../../Pages/FreeFeMaterials/Mechanical";
import FreeFeTestCivil from "../../Pages/FreeFeTest/Civil";
import FreeFeTestMechanical from "../../Pages/FreeFeTest/Mechanical";
import Home from "../../Pages/Home";
import LiveClassCivil from "../../Pages/LiveClass/Civil";
import LiveClassMechanical from "../../Pages/LiveClass/Mechanical";
import LiveOnlineClass from "../../Pages/LiveOnlineClass";
import NewsItem from "../../Pages/News";
import NewsArchive from "../../Pages/NewsArchive";
import PaidModelTestCivil from "../../Pages/PaidModelTestCivil/Civil";
import PaidModelTestMechanical from "../../Pages/PaidModelTestCivil/Mechanical";
import PracticeHub from "../../Pages/PracticeHub";
import MechanicalPracticeHub from "../../Pages/PracticeHub/Mechanical";
import QuizBank from "../../Pages/QuizBank";
import MechanicalQuizBank from "../../Pages/QuizBank/Mechanical";
import SelfStudy from "../../Pages/SelfStudy";
import SimulatorCivil from "../../Pages/Simulator/Civil";
import SimulatorMechanical from "../../Pages/Simulator/Mechanical";
import SubscriptionMaterials from "../../Pages/SubscriptionMaterials";
import MechanicalSubscriptionMaterials from "../../Pages/SubscriptionMaterials/Mechanical";
import Tutorial from "../../Pages/Tutorial";
import TutoringCivil from "../../Pages/Tutoring/Civil";
import TutoringMechanical from "../../Pages/Tutoring/Mechanical";
import PublicLayout from "./PublicLayout";
import StaticPage from "../../Pages/StaticPage";
import BlogDetail from "../../Pages/Blog";
import BlogArchive from "../../Pages/Blogs";

export const publicRoutes = [
  {
    route: publicUrls.Home,
    element: (
      <PublicLayout>
        <Home />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.About,
    element: (
      <PublicLayout>
        <AboutUs />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.Contact,
    element: (
      <PublicLayout>
        <ContactUs />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.NewsArchive,
    element: (
      <PublicLayout>
        <NewsArchive />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.LiveOnlineClass,
    element: (
      <PublicLayout>
        <LiveOnlineClass />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.Tutorial,
    element: (
      <PublicLayout>
        <Tutorial />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.SelfStudy,
    element: (
      <PublicLayout>
        <SelfStudy />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.News,
    element: (
      <PublicLayout>
        <NewsItem />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.BlogsArchive,
    element: (
      <PublicLayout>
        <BlogArchive />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.Blog,
    element: (
      <PublicLayout>
        <BlogDetail />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.PrivacyPolicies,
    element: (
      <PublicLayout>
        <StaticPage />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.TermsOfServices,
    element: (
      <PublicLayout>
        <StaticPage />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.CivilCourses,
    element: (
      <PublicLayout>
        <FeCivil />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.MechanicalCourses,
    element: (
      <PublicLayout>
        <FeMechanical />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.LiveClassCivil,
    element: (
      <PublicLayout>
        <LiveClassCivil />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.LiveClassMechanical,
    element: (
      <PublicLayout>
        <LiveClassMechanical />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.FreeFeTestCivil,
    element: (
      <PublicLayout>
        <FreeFeTestCivil />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.FreeFeTestMechanical,
    element: (
      <PublicLayout>
        <FreeFeTestMechanical />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.FreeFeMaterialsCivil,
    element: (
      <PublicLayout>
        <FreeFeMaterialsCivil />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.FreeFeMaterialsMechanical,
    element: (
      <PublicLayout>
        <FreeFeMaterialsMechanical />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.PaidModelTestCivil,
    element: (
      <PublicLayout>
        <PaidModelTestCivil />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.PaidModelTestMechanical,
    element: (
      <PublicLayout>
        <PaidModelTestMechanical />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.tutoringCivil,
    element: (
      <PublicLayout>
        <TutoringCivil />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.tutoringMechanical,
    element: (
      <PublicLayout>
        <TutoringMechanical />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.feSubscriptionCivil,
    element: (
      <PublicLayout>
        <SubscriptionMaterials />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.feSubscriptionMechanical,
    element: (
      <PublicLayout>
        <MechanicalSubscriptionMaterials />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.practiceHubCivil,
    element: (
      <PublicLayout>
        <PracticeHub />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.practiceHubMechanical,
    element: (
      <PublicLayout>
        <MechanicalPracticeHub />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.quizBankCivil,
    element: (
      <PublicLayout>
        <QuizBank />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.quizBankMechanical,
    element: (
      <PublicLayout>
        <MechanicalQuizBank />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.simulatorCivil,
    element: (
      <PublicLayout>
        <SimulatorCivil />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.simulatorMechanical,
    element: (
      <PublicLayout>
        <SimulatorMechanical />
      </PublicLayout>
    ),
  },
  {
    route: publicUrls.staticPage,
    element: (
      <PublicLayout>
        <StaticPage />
      </PublicLayout>
    ),
  },
];
